const search_service_config = {
    kubernetes_dev: { timeout: 5000, retries: 1 },
    prod: { timeout: 800, retries: 1 }
};

const cms_service_timout = {
    kubernetes_dev: 2000,
    prod: 100
};

const seo_service_timeout = {
    kubernetes_dev: 2000,
    prod: 100
};

const getSearchServiceConfig = (env) => search_service_config[env] || search_service_config.prod;
const getCmsServiceConfig = (env) => cms_service_timout[env] || cms_service_timout.prod;
const getSeoServiceConfig = (env) => seo_service_timeout[env] || seo_service_timeout.prod;

const config = {
    name: 'search',
    app_name: 'search_perseus',
    port: 9329,
    NODE_ENV: process.env.NODE_ENV,
    serve_modern_bundle: true,
    copies_to_load: [
        'categories_chimera/v1/categories',
        'categories_chimera/v1/sub_categories',
        'seo_chimera/seo_sub_categories',
        'pricing_chimera/v1/pricing_factors',
        'extended_attributes_chimera/v1/metadata'
    ],
    logger: {
        host: `${process.env.GENERAL_SERVICES_RELAY_SERVICE}/v1/log/logger`,
        facility: 'search_perseus',
        logLevel: process.env.MICROSERVICES_SEARCH_PERSEUS_LOG_LEVEL || 'error',
        mode: process.env.NODE_ENV
    },
    statsd: {
        tech: {
            host: process.env.GENERAL_STATSD_HOST,
            port: process.env.GENERAL_STATSD_PORT,
            prefix: 'services.search_perseus'
        },
        biz: {
            host: process.env.GENERAL_STATSD_HOST,
            port: process.env.GENERAL_STATSD_BIZ_PORT,
            prefix: 'services.search_perseus'
        }
    },
    stats: {
        server: {
            host: process.env.GENERAL_STATSD_HOST,
            port: process.env.GENERAL_STATSD_PORT,
            mode: process.env.NODE_ENV
        }
    },
    api_prefix: '/v4/search',
    listings_service: {
        url: process.env.GENERAL_SERVICES_GO_LISTINGS_PHOENIX_SERVICE
    },
    search_service: {
        url: `${process.env.GENERAL_SERVICES_GO_SEARCH_SERVICE}/api/v5`,
        timeout: getSearchServiceConfig(process.env.KUBE_ENV).timeout,
        retries: getSearchServiceConfig(process.env.KUBE_ENV).retries
    },
    machine_translation_service: {
        url: `http://${process.env.GENERAL_SERVICES_MACHINE_TRANSLATION_SERVICE}/api/v1`
    },
    translations_vertical_kimera: {
        url: `http://${process.env.GENERAL_SERVICES_TRANSLATIONS_VERTICAL_KIMERA_SERVICE}/api/v1`
    },
    mixpanel: {
        token: process.env.GENERAL_MIXPANEL_TOKEN
    },
    recommendations_service: {
        url: `${process.env.GENERAL_SERVICES_RECOMMENDATIONS_SERVICE}/api/v2`
    },
    cms_service: {
        url: `${process.env.GENERAL_SERVICES_CMS_SERVICE}/api/v1`,
        timeout: getCmsServiceConfig(process.env.KUBE_ENV)
    },
    website_creation_chimera_service: {
        url: `${process.env.GENERAL_SERVICES_WEBSITE_CREATION_CHIMERA_SERVICE}/api/v1`
    },
    redis: {
        main: {
            host: process.env.GENERAL_REDIS_MAIN_HOST,
            port: process.env.GENERAL_REDIS_MAIN_PORT
        },
        search: {
            host: process.env.GENERAL_REDIS_SEARCH_HOST,
            port: process.env.GENERAL_REDIS_SEARCH_PORT
        }
    },
    reviews_kimera: {
        url: `http://${process.env.GENERAL_SERVICES_REVIEWS_KIMERA_SERVICE}/api/v1`
    },
    seo_service: {
        url: `http://${process.env.GENERAL_SERVICES_SEO_SERVICE}/api/v1`,
        timeout: getSeoServiceConfig(process.env.KUBE_ENV)
    },
    experiment_service: {
        url: `http://${process.env.GENERAL_SERVICES_EXPERIMENT_SERVICE}/api/v1`
    },
    rollout_pegasus: {
        url: process.env.GENERAL_SERVICES_ROLLOUT_PEGASUS
    }
};

module.exports = config;
